import React, { Component } from "react";
import "./Home.css";
import {  ListGroup ,ListGroupItem ,ButtonGroup ,Button,Jumbotron} from "react-bootstrap";
import {Auth, API ,PubSub} from "aws-amplify";
import { AWSIoTProvider } from '@aws-amplify/pubsub/lib/Providers';

import Moment from 'react-moment';
import AUTHMD from '../md/HomeAuthenticated.md'
import UNAUTHMD from '../md/HomeUnAuthenticated.md'

import ReactMarkdown from 'react-markdown/with-html'


export default class Home extends Component {
    constructor(props) {
      super(props);
      this.state = {
        md_auth:null,
        md_unauth:null
      };
    }

    async componentWillMount() {

      console.log("MQTT TEST")




      fetch(AUTHMD)
        .then((res) => res.text())
        .then((md_auth) => {
          console.log(md_auth)
          this.setState({ md_auth })
        })
      fetch(UNAUTHMD)
        .then((res) => res.text())
        .then((md_unauth) => {
          console.log(md_unauth)
          this.setState({ md_unauth })
        })

    }


    render() {
      return (
          <div className="Home">
          <Jumbotron>


            {this.props.isAuthenticated ? <ReactMarkdown className="CenterText" source={this.state.md_auth}  escapeHtml={false} /> : <ReactMarkdown className="CenterText" source={this.state.md_unauth}  escapeHtml={false}/>}
            </Jumbotron>
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Home.js